import { useEffect } from "react";
import { useLocation } from "react-router-dom";

// FIX: Har route change pe page top pe scroll karo
// React SPA mein route change hone pe scroll position wahi rehti hai
// jahan user tha — yeh component globally fix karta hai

const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
    // "instant" use kiya — "smooth" se lag tha ki page jump kar raha hai
  }, [pathname]);

  return null; // kuch render nahi karta
};

export default ScrollToTop;
